
// Change text captialize format
// ex: 'iron, man' -'Iron, Man'  &  'iron,man' -'Iron Man'
export const TitleCase = (str) => {
    if (str) {
        return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
    }
    return str;

};



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/caseFormat.ts